require('./beneficiaryNew.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const transfersHelper = require('utilities/transfersHelper');
// @ components
const BeneficiaryNewAccounts = require('components/transfersSteps/transferSteps/transferStep1//beneficiaryNewAccounts/beneficiaryNewAccounts');
const { InputSafe } = require('commonsComponents/inputSafe');
const SearchCountries = require('components/searchCountries/searchCountries');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ constants
const { currenciesOptions } = require('constants/currencies');
const { DEFAULT_COUNTRY, EURO_TEXT } = require("constants/index");

class BeneficiaryNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.immBeneficiaryNew.get('name'),
            alias: props.immBeneficiaryNew.get('alias'),
            address: props.immBeneficiaryNew.get('address'),
            city: props.immBeneficiaryNew.get('city')
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAliasChange = this.handleAliasChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleNameBlur = this.handleNameBlur.bind(this);
        this.handleAliasBlur = this.handleAliasBlur.bind(this);
        this.handleAddressBlur = this.handleAddressBlur.bind(this);
        this.handleCityBlur = this.handleCityBlur.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.buildSelectCurrency = this.buildSelectCurrency.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { immBeneficiaryNew } = nextProps;
        const { state } = this;
        const address = immBeneficiaryNew.get('address');
        const city = immBeneficiaryNew.get('city');
        const name = immBeneficiaryNew.get('name');
        const alias = immBeneficiaryNew.get('alias');

        if (address !== state.address) {
            this.setState({
                address
            });
        }

        if (city !== state.city) {
            this.setState({
                city
            });
        }

        if (name !== state.name) {
            this.setState({
                name
            });
        }

        if (alias !== state.alias) {
            this.setState({
                alias
            });
        }
    }

    buildMessageEditBeneficiary() {
        const { immBeneficiaryNew } = this.props;

        if (immBeneficiaryNew.get('isEditingBeneficiaryExisting')) {
            return (
                <OKMessage type="important" >
                    <FormattedText value="transferSummary-step1MessageBeneficiaryEdition" />
                </OKMessage>
            )
        }
    }

    buildNationalTransferIbanWarning() {
        const { immBeneficiaryNew, originCountry } = this.props;
        let warning = null;
        if ( !__CONTACT_CENTER__ && originCountry === DEFAULT_COUNTRY && immBeneficiaryNew.get('country') === DEFAULT_COUNTRY && immBeneficiaryNew.get('currency') === EURO_TEXT) {
            warning = (
                <div className='transfer-beneficiary-new__national-transfer-iban-warning'>
                    <OKMessage type="important">
                        <FormattedText value="transferSummary-transferSummary_step1NationalTransferIbanWarning" />
                    </OKMessage>
                </div>
            );
        }
        return warning;
    }

    buildOutsideSepaExtraFields() {
        const { immBeneficiaryNew, isEditingScheduled } = this.props;

        const labelAddress = formatText('transferSummary-step1BeneficiaryAddress');
        const labelCity = formatText('transferSummary-step1BeneficiaryCity');
        const isSepa = transfersHelper.isSepa(
            immBeneficiaryNew.get('country'),
            immBeneficiaryNew.get('currency')
        );

        let content;
        if (!isSepa) {
            content = (
                <div className="transfer-first-step__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryAddress"
                                type="text"
                                autoComplete="off"
                                label={labelAddress}
                                value={this.state.address}
                                onChange={this.handleAddressChange}
                                onBlur={this.handleAddressBlur}
                                maxLength="100"
                                disabled={isEditingScheduled}
                            />
                        </div>
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryCity"
                                type="text"
                                autoComplete="off"
                                label={labelCity}
                                value={this.state.city}
                                onChange={this.handleCityChange}
                                onBlur={this.handleCityBlur}
                                maxLength="50"
                                disabled={isEditingScheduled}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }

    buildSelectCurrency() {
        const { immBeneficiaryNew, isEditingScheduled, actions } = this.props;
        let currencyContent;
        const currency = immBeneficiaryNew.get('currency');
        const labelCurrency = formatText('transferSummary-step1Currency');
        currencyContent = (
            <OKSelect
                label={labelCurrency}
                options={currenciesOptions()}
                value={currency}
                searchable={false}
                clearable={false}
                onChange={actions.handleCurrency}
                disabled={isEditingScheduled}
            />
        );

        return currencyContent;
    }

    handleAddressBlur(evt) {
        this.props.actions.setBeneficiaryAddress(evt.target.value);
    }

    handleAddressChange(evt) {
        this.setState({
            address: evt.target.value
        });
    }

    handleAliasBlur(evt) {
        const alias = evt.target.value.trim();
        const isValid = !!alias && !this.isAliasRepeated(alias);
        //update state after trim , and the update reducer
        this.setState(
            {
                alias: alias
            },
            () => {
                this.props.actions.setBeneficiaryAlias(alias, isValid);
            }
        );
    }

    handleAliasChange(evt) {
        this.setState({
            alias: evt.target.value
        });
    }

    handleCityBlur(evt) {
        this.props.actions.setBeneficiaryCity(evt.target.value);
    }

    handleCityChange(evt) {
        this.setState({
            city: evt.target.value
        });
    }

    handleCountryChange(country) {
        const {
            actions: { handleBeneficiaryCountry, setIbanOnCountryChange },
            immBeneficiaryNew,
            resetBankName
        } = this.props;
        resetBankName();
        handleBeneficiaryCountry(country);
        setIbanOnCountryChange(immBeneficiaryNew.get('ibanIsDirty'));
    }

    handleNameBlur(evt) {
        this.props.actions.setBeneficiaryName(evt.target.value);
    }

    handleNameChange(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    isAliasRepeated(alias) {
        const { immBeneficiaries } = this.props;
        return immBeneficiaries.get('byOrder').some(beneficiaryId => {
            return (
                immBeneficiaries.getIn(['byId', beneficiaryId, 'alias']).toLowerCase() ===
                alias.toLowerCase()
            );
        });
    }

    render() {
        const {
            immBankEntity,
            immBeneficiaryNew,
            isEditingScheduled,
            isReusingTransfer,
            actions,
            handleBeneficiary,
            getProductOffers,
            resetBankName
        } = this.props;

        const labelName = formatText('transferSummary-step1BeneficiaryName');
        const labelAlias = formatText('transferSummary-step1BeneficiaryAlias');

        const nameRequiredAlertVisible = immBeneficiaryNew.get('nameIsDirty') && immBeneficiaryNew.get('name') === '';
        const nameRequiredErrorMsg = formatText('transferSummary-requiredMessage', [labelName]);

        const aliasRequiredAlertVisible = immBeneficiaryNew.get('aliasIsDirty') && immBeneficiaryNew.get('alias') === '';
        const aliasRepeatedAlertVisible = immBeneficiaryNew.get('aliasIsDirty') && !immBeneficiaryNew.get('aliasIsValid');
        let aliasErrorMsg = formatText('transferSummary-step1AliasRepeated');

        if (aliasRequiredAlertVisible) {
            aliasErrorMsg = formatText('transferSummary-requiredMessage', [labelAlias]);
        }

        const labelCountry = formatText('transferSummary-step1BeneficiaryCountryDestiny');

        const outsideSepaExtraFields = this.buildOutsideSepaExtraFields();
        const selectCurrencyContent = this.buildSelectCurrency();
        const buildMessageEditBeneficiary = this.buildMessageEditBeneficiary();
        const nationalTransferIbanWarning = this.buildNationalTransferIbanWarning();
        let aliasContent, addBeneficiaryContent;
        const isEditingBeneficiaryExisting = immBeneficiaryNew.get('isEditingBeneficiaryExisting');

        const beneficiaryNewStyle = classnames('transfer-beneficiary-new', {
            'transfer-beneficiary-new--editing': isEditingBeneficiaryExisting
        });


        if (!isEditingScheduled && !isReusingTransfer) {
            const addBeneficiary = immBeneficiaryNew.get('addBeneficiary');
            if (!isEditingBeneficiaryExisting) {
                addBeneficiaryContent = (
                    <div className="transfer-first-step__form-section">
                        <OKCheckbox
                            idName="chk_TransferStep1_AddBeneficiary"
                            value={addBeneficiary}
                            onChange={actions.handleAddBeneficiary}
                            label={formatText('transferSummary-step1AddBeneficiary')}
                        />
                    </div>
                );
            }

            if (addBeneficiary || isEditingBeneficiaryExisting) {
                aliasContent = (
                    <div className="col-xs-6">
                        <InputSafe
                            id={'inp_TransferStep1_BeneficiaryAlias'}
                            label={labelAlias}
                            type="text"
                            autoComplete="off"
                            value={this.state.alias}
                            onChange={this.handleAliasChange}
                            onBlur={this.handleAliasBlur}
                            errorState={aliasRequiredAlertVisible || aliasRepeatedAlertVisible}
                            errorMessage={aliasErrorMsg}
                            maxLength="50"
                            disabled={isEditingBeneficiaryExisting}
                        />
                    </div>
                );

            }
        }

        return (
            <div className={beneficiaryNewStyle}>
                <div className="transfer-first-step__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <InputSafe
                                id={'inp_TransferStep1_BeneficiaryName'}
                                label={labelName}
                                type="text"
                                autoComplete="off"
                                value={this.state.name}
                                onChange={this.handleNameChange}
                                onBlur={this.handleNameBlur}
                                errorState={nameRequiredAlertVisible}
                                errorMessage={nameRequiredErrorMsg}
                                maxLength="50"
                            />
                        </div>
                        {aliasContent}
                    </div>
                </div>
                {addBeneficiaryContent}
                <div className="transfer-first-step__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <SearchCountries
                                label={labelCountry}
                                selectedValue={immBeneficiaryNew.get('country')}
                                onSelect={this.handleCountryChange}
                                disabled={isEditingScheduled}
                            />
                        </div>
                        <div className="col-xs-6">
                            {selectCurrencyContent}
                        </div>
                    </div>
                </div>
                {outsideSepaExtraFields}
                <BeneficiaryNewAccounts
                    immBankEntity={immBankEntity}
                    immBeneficiaryNew={immBeneficiaryNew}
                    actions={actions}
                    resetBankName={resetBankName}
                    isEditingScheduled={isEditingScheduled}
                    handleBeneficiary={handleBeneficiary}
                    getProductOffers={getProductOffers}
                />
                {nationalTransferIbanWarning}
                {buildMessageEditBeneficiary}
            </div>
        );
    }
}

BeneficiaryNew.propTypes = {
    actions: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    immBeneficiaryNew: PropTypes.object,
    isEditingScheduled: PropTypes.bool,
    isReusingTransfer: PropTypes.bool,
    resetBankName: PropTypes.func,
    handleBeneficiary: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    getProductOffers: PropTypes.func.isRequired,
};

module.exports = { BeneficiaryNew };
